import {BACKEND_API, serialize} from '../middleware/backend'

export const TRANSACTIONS_REQUEST = 'TRANSACTIONS_REQUEST';
export const TRANSACTIONS_SUCCESS = 'TRANSACTIONS_SUCCESS';
export const TRANSACTIONS_FAILURE = 'TRANSACTIONS_FAILURE';
export const TRANSACTIONS_COUNT_REQUEST = 'TRANSACTIONS_COUNT_REQUEST';
export const TRANSACTIONS_COUNT_SUCCESS = 'TRANSACTIONS_COUNT_SUCCESS';
export const TRANSACTIONS_COUNT_FAILURE = 'TRANSACTIONS_COUNT_FAILURE';
export const TRANSACTION_REQUEST = 'TRANSACTION_REQUEST';
export const TRANSACTION_SUCCESS = 'TRANSACTION_SUCCESS';
export const TRANSACTION_FAILURE = 'TRANSACTION_FAILURE';
export const TRANSACTIONS_FIND_REQUEST = 'TRANSACTIONS_FIND_REQUEST';
export const TRANSACTIONS_FIND_SUCCESS = 'TRANSACTIONS_FIND_SUCCESS';
export const TRANSACTIONS_FIND_FAILURE = 'TRANSACTIONS_FIND_FAILURE';
export const TRANSACTION_SAVE_REQUEST = 'TRANSACTION_SAVE_REQUEST';
export const TRANSACTION_SAVE_SUCCESS = 'TRANSACTION_SAVE_SUCCESS';
export const TRANSACTION_SAVE_FAILURE = 'TRANSACTION_SAVE_FAILURE';
export const TRANSACTION_DELETE_REQUEST = 'TRANSACTION_DELETE_REQUEST';
export const TRANSACTION_DELETE_SUCCESS = 'TRANSACTION_DELETE_SUCCESS';
export const TRANSACTION_DELETE_FAILURE = 'TRANSACTION_DELETE_FAILURE';

export const TRANSACTION_MASS_UPDATE_REQUEST = 'TRANSACTION_MASS_UPDATE_REQUEST';
export const TRANSACTION_MASS_UPDATE_SUCCESS = 'TRANSACTION_MASS_UPDATE_SUCCESS';
export const TRANSACTION_MASS_UPDATE_FAILURE = 'TRANSACTION_MASS_UPDATE_FAILURE';

export const loadTransactions = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [TRANSACTIONS_REQUEST, TRANSACTIONS_SUCCESS, TRANSACTIONS_FAILURE],
			endpoint: "transaction/list",
			filter: filter
		}
	})
};

export const countTransactions = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [TRANSACTIONS_COUNT_REQUEST, TRANSACTIONS_COUNT_SUCCESS, TRANSACTIONS_COUNT_FAILURE],
			endpoint: "transaction/count",
			filter: filter
		}
	})
};

export const loadTransaction = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [TRANSACTION_REQUEST, TRANSACTION_SUCCESS, TRANSACTION_FAILURE],
			endpoint: `transaction/${id}`,
		}
	})
};

export const findTransactions = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [TRANSACTIONS_FIND_REQUEST, TRANSACTIONS_FIND_SUCCESS, TRANSACTIONS_FIND_FAILURE],
			endpoint: "transaction/find",
			filter: filter
		}
	})
};

export const saveTransaction = (transaction) => (dispatch, getState) => {

	const formData = new FormData();
	const values = Object.assign({}, transaction);
	if (values.photo) {
		if (values.photo[0]) {
			formData.append('photo', values.photo[0]);
		}
		values.photo = undefined
	}
	formData.append('transaction', serialize(values));


	return dispatch({
		transaction: transaction,
		[BACKEND_API]: {
			types: [TRANSACTION_SAVE_REQUEST, TRANSACTION_SAVE_SUCCESS, TRANSACTION_SAVE_FAILURE],
			endpoint: transaction && transaction.transactionId ? `transaction/${transaction.transactionId}` : 'transaction',
			body: formData
		}
	})
};

export const deleteTransaction = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [TRANSACTION_DELETE_REQUEST, TRANSACTION_DELETE_SUCCESS, TRANSACTION_DELETE_FAILURE],
			endpoint: `transaction/${id}`,
			method: 'DELETE'
		}
	})
};

export const massUpdateTransactions = (payload) => (dispatch, getState) => {

	return dispatch({
		[BACKEND_API]: {
			types: [TRANSACTION_MASS_UPDATE_REQUEST, TRANSACTION_MASS_UPDATE_SUCCESS, TRANSACTION_MASS_UPDATE_FAILURE],
			endpoint: `transaction/mass-update`,
			body: payload
		}
	})
};
